export default "__VITE_ASSET__2YSmTqck__"